export default {
    hospital: {
        dataTableId: 'hospital:name',
        value: [],
    },
    status: {
        dataTableId: 'status:name',
        value: [],
    },
    search: {
        dataTableId: 'search',
        value: '',
    },
    page: {
        value: 0,
    },
    length: {
        value: 25,
    },
};
